import { create } from "zustand";

const useWaterMeterStore = create((set) => ({
    waterMeters: [], //watermeters to be mounted
    setWaterMeters: (value) => set((state) => ({...state, waterMeters: value}))
}));

export default useWaterMeterStore;
